import RiskRuleSetting from "./RiskRuleSetting";
export default RiskRuleSetting;